import clsx from "clsx";
import "../Tags.scss";

export type TagMode = "filter" | "decorative";
export type TagProps = {
  label: string;
  mode?: TagMode;
  className?: string;
  selected?: boolean;
  onClick?: () => void;
};

export const Tag = ({
  label,
  mode = "decorative",
  selected = false,
  className,
  onClick,
}: TagProps) => {
  const TagComponent = mode === "decorative" ? "div" : "button";

  return (
    <TagComponent
      className={clsx("tag", { selected: selected }, className)}
      onClick={onClick}
    >
      {label}
    </TagComponent>
  );
};
